"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

var _xlsx = require("xlsx");

var _xlsx2 = _interopRequireDefault(_xlsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersController = function () {
  function UsersController(UsersService, FilterService, AuthService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UsersController);
    this.usersService = UsersService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";
  }

  (0, _createClass3.default)(UsersController, [{
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        // selectable: "multiple cell",
        // allowCopy: true,
        dataSource: this.usersService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        height: "90vh",
        noRecords: {
          template: "No match found. Change your filter criteria."
        },
        columns: [{
          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "12rem",
          template: function template(dataItem) {
            return "<a class=\"cell\" href=\"/users/" + dataItem.userId + "\"><div class=\"image-container\"><img src=\"" + (dataItem.imageUrl ? _this.imageBaseUrl + dataItem.imageUrl : "/images/user-image-unavailable.png") + "\"></img></div><span>" + dataItem.fullName + "</span></a>";
          }
        }, { field: "entityTypeName", title: "Account Type", filterable: false, attributes: { class: "col-account-type" }, width: "8rem" }, { field: "userId", title: "User Id", filterable: false, width: "6rem", template: function template(dataItem) {
            return "<a href=\"/users/" + dataItem.userId + "\">" + dataItem.userId + "</a>";
          } }, // { field: "membershipTypeName", title: "Membership Type", filterable: false, width: "10rem" },
        { field: "accountStatusName", title: "Account Status", filterable: false, width: "8rem" }, {
          field: "email", title: "Email", filterable: false, width: "15rem",
          template: "<a href=\"mailto:#= email #\">#= email #</a>"
        }, { field: "creationDate", title: "Signup Date", template: "<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>", filterable: false, width: "8rem" }, { field: "phoneNumber", title: "Phone Number", filterable: false, width: "10rem" }, { field: "suburb", title: "Suburb", filterable: false, width: "8rem" },
        // { field: "state", title: "State/Region", filterable: false, width: "8rem" },
        { field: "country", title: "Country", filterable: false, width: "6rem" }]
      };
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "exportToExcel",
    value: function exportToExcel() {
      var ds = this.gridOptions.dataSource;
      var currentFilters = ds.filter() || {};
      var filters = currentFilters.filters || [];
      var total = ds.total();

      var payload = (0, _stringify2.default)({
        filters: filters,
        page: 1,
        pageSize: total || 100000,
        skip: 0,
        take: total || 100000
      });

      var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");

      fetch(_env2.default.getApiUrl("entities/search"), {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": token },
        body: payload
      }).then(function (r) {
        return r.json();
      }).then(function (result) {
        var rows = (result.data || []).map(function (u) {
          return {
            Name: u.fullName,
            "Account Type": u.entityTypeName,
            "Account Status": u.accountStatusName,
            Email: u.email,
            "Phone Number": u.phoneNumber || '',
            "Signup Date": u.creationDate ? new Date(u.creationDate).toLocaleDateString('en-GB') : '',
            Suburb: u.suburb,
            Country: u.country
          };
        });
        var ws = _xlsx2.default.utils.json_to_sheet(rows);
        var wb = _xlsx2.default.utils.book_new();
        _xlsx2.default.utils.book_append_sheet(wb, ws, "Users");
        var fileName = "users_" + (0, _moment2.default)().format('YYYY-MM-DD_HH-mm-ss') + ".xlsx";
        _xlsx2.default.writeFile(wb, fileName);
      });
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.usersMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }]);
  return UsersController;
}();

exports.default = UsersController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/users/users.controller.js
 **/